package models

import kotlinx.serialization.Serializable

@Serializable
data class PlayerData(
    val id: Int,
    var x: Float,
    var y: Float
) : PacketData()

/**
 * Physic synchronization
 */
@Serializable
data class PlayerPhysicStates(
    val sequence: Int,
    val states: List<PhysicState>
) : PacketData()

@Serializable
data class SessionInfo(
    val sessionId: String,
    val serverStartTime: Long,
    val player: PlayerData,
    val otherPlayers: List<PlayerData>
) : PacketData()